export default __webpack_public_path__ + "static/media/gym-img-06.96e2e357.jpg";